export default class EditStatementCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
  // constants
    var statementVm = this
  // variables
    const shared = PortfolioModalSrv.getVariable()
    statementVm.userId      = shared.userId
    statementVm.description = (shared.statement.blogDescription ? shared.statement.blogDescription : '')
    statementVm.attachFile  = (shared.statement.externalUrlFiles ? shared.statement.externalUrlFiles : []) 
    statementVm.errorMsg    = false

  // methods
    statementVm.close             = close
    statementVm.addStatement      = addStatement
    statementVm.showErrorMessages = showErrorMessages
    statementVm.hasError          = hasError
    statementVm.validateForm      = validateForm    
    statementVm.remove            = remove

    activate()
    
  //initial functions
    function activate(){
      console.log(statementVm.attachFile)
    }

    function close (){
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    function addStatement() {
      statementVm.description = removeSymbol(statementVm.description)
      let header = {
        userId      : statementVm.userId,
        description : statementVm.description,
        attachFiles : statementVm.attachFile
      }
      console.log(header)
      PortfolioSrv.addStatement.add(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()
        } 
      })
    }

    function removeSymbol(str){
      return str.replaceAll('>?','>')
    }
    
  //upload methods
    var uploader = $scope.uploader = new FileUploader({
      url: SERVICE_URL_CONSTANT.rosario+'/file/uploadFilePortfolio?userId='+statementVm.userId 
    })

   // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
      console.log('syncFilter');
      return this.queue.length < 10;
      }
    })

   // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item /*{File|FileLikeObject}*/, options, deferred) {
        console.log('asyncFilter')
        setTimeout(deferred.resolve, 1e3)
      }
    })
    uploader.onSuccessItem = function(fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers)
      if(response.status){
        statementVm.urlFilename = response.data
        statementVm.attachFile.push({filename : fileItem.file.name, externalUrlFile : statementVm.urlFilename})  
        statementVm.errorMsg    = false
      }
      
    }
    uploader.onErrorItem = function(fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers)
      statementVm.errorMsg = true
    }

    uploader.onCompleteItem = function(fileItem, response, status, headers) {
      console.info('onCompleteItem', fileItem, response, status, headers)
      statementVm.loading = false
      uploader.clearQueue()
    }

    uploader.onBeforeUploadItem = function(item) {
      let header = {
        userId : statementVm.userId,
      }
      item.formData.push(header);
      statementVm.loading  = true
      statementVm.errorMsg = false
    }

    function remove(index){
      statementVm.loading  = false
      statementVm.errorMsg = false
      statementVm.attachFile.splice(index,1) 
    }



  //forms methods
    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid
    } 


    String.prototype.replaceAll = function(searchStr, replaceStr) {
      var str = this;
      if(str.indexOf(searchStr) === -1) 
        return str
      return (str.replace(searchStr, replaceStr)).replaceAll(searchStr, replaceStr);
    }

  }
}

EditStatementCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 
                              'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/editStatementCtrl.js